/** 랜딩 Q&A 범주(앱 페이지·기능 묶음). 질문 앞에 태그로 표시된다. */
export const LANDING_FAQ_CATEGORIES = [
  '서비스 안내',
  '학사일정·시간표',
  '편제·기준시수',
  '진도·프로그램',
  '과제·포인트',
  '수업 프레젠테이션',
  '메인 프레젠테이션',
  '평가·기록',
  '개인 업무',
  '이용권·보안',
] as const;

export type LandingFaqCategory = (typeof LANDING_FAQ_CATEGORIES)[number] | string;

export interface LandingFaqItem {
  id: string;
  sort_order: number;
  category: string;
  question: string;
  answer: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface LandingFaqDraft {
  id: string;
  category: string;
  question: string;
  answer: string;
  is_active: boolean;
  /** 아직 DB에 없는 신규 항목 */
  isNew?: boolean;
}
